import React from 'react';
import { asyncConnect } from 'redux-connect';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

import { loadPopularDestinations } from 'actions';
import { createDefaultPromise } from 'utils';
import {
  bikeTypesSelector,
  countriesSelector,
  currencySelector,
  popularDestinationsSelector
} from 'selectors';
import SubscribeFormSection from 'widgets/SubscribeFormSection';

import AdvantagesSection from './AdvantagesSection';
import LeadSection from './LeadSection';
import HowItWorksSection from './HowItWorksSection';
import ReviewsSection from './ReviewsSection';
import PopularSection from './PopularSection';
import FAQSection from './FAQSection';

import './HomePage.css';

const HomePage = ({
  countries,
  currency,
  bikeTypes,
  popularDestinations
}) => {
  const initialState = {
    beginDateTime: moment()
      .add(5, 'day')
      .startOf('day')
      .set('hour', 10)
      .toISOString(),
    endDateTime: moment()
      .add(8, 'day')
      .startOf('day')
      .set('hour', 10)
      .toISOString()
  };

  return (
    <div className="home-page">
      <LeadSection
        countries={countries}
        bikeTypes={bikeTypes}
        initialState={initialState}
      />

      <HowItWorksSection />

      <ReviewsSection />

      <AdvantagesSection />

      {(!!popularDestinations && !!popularDestinations.length) && (
        <PopularSection
          currency={currency}
          popularDestinations={popularDestinations}
          bikeTypes={bikeTypes}
        />
      )}

      <FAQSection />

      <SubscribeFormSection />
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  currency: currencySelector,
  countries: countriesSelector,
  bikeTypes: bikeTypesSelector,
  popularDestinations: popularDestinationsSelector
});

export default asyncConnect(
  [{ promise: createDefaultPromise(popularDestinationsSelector, loadPopularDestinations) }],
  mapStateToProps
)(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js